import Portfolio from '../portfolio';

/**
 * Create the action
 */

const { thunk, request, success, error } = Portfolio.show((sharecode, fetch) => {
    return fetch.get(`/portfolio/show-sharecode/${sharecode}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
